
















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { ITemplate } from '@/store/modules/templatesaver'

@Component({})
export default class TemplateLine extends Vue {
  @Prop({
    required: true
  })
  value: ITemplate

  remove() {
    this.$emit('remove', this.value)
  }

  @Watch('value', { deep: true })
  watchValue() {
    this.$emit('input', this.value)
  }
}
